module.exports = __webpack_public_path__ + "img/shops_shop_front.83a7ac71.jpg";